// extracted by mini-css-extract-plugin
module.exports = {"spaceName":"styles_spaceName__4x9k9"};